import React, { useEffect, useState } from "react";

const ThemeSwitcher = () => {
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem("theme");
    return (
      savedTheme ||
      (window.matchMedia("(prefers-color-scheme: dark)").matches
        ? "dark"
        : "light")
    );
  });

  useEffect(() => {
    const applyTheme = (theme) => {
      document.documentElement.setAttribute("data-bs-theme", theme);
    };

    applyTheme(theme);

    const handleMediaChange = () => {
      const prefersDark = window.matchMedia(
        "(prefers-color-scheme: dark)"
      ).matches;
      if (!localStorage.getItem("theme")) {
        setTheme(prefersDark ? "dark" : "light");
      }
    };

    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    mediaQuery.addEventListener("change", handleMediaChange);

    return () => {
      mediaQuery.removeEventListener("change", handleMediaChange);
    };
  }, [theme]);

  const toggleTheme = () => {
    const newTheme = theme === "dark" ? "light" : "dark";
    setTheme(newTheme);
    localStorage.setItem("theme", newTheme);
  };

  return (
    <div className="d-flex justify-content-center align-items-center">
      {theme === "light" ? (
        <button
          className="btn btn-light btn-icon rounded-circle d-flex align-items-center"
          type="button"
          aria-label="Switch to dark mode"
          onClick={toggleTheme}
        >
          <i className="bi bi-moon"></i>
        </button>
      ) : (
        <button
          className="btn btn-dark btn-icon rounded-circle d-flex align-items-center"
          type="button"
          aria-label="Switch to light mode"
          onClick={toggleTheme}
        >
          <i className="bi bi-sun"></i>
        </button>
      )}
    </div>
  );
};

export default ThemeSwitcher;
